import { IExcelRowDecorator } from "../../../../../../common/component/list/import-export-list/iexcel-row-decorator";
import * as Excel from "exceljs";
import { ExportDataValue } from "../../../../../model/export-data-item";

export class ExcelEditableColumnDecorator implements IExcelRowDecorator {
    private readonly _editableColumnsIndex: number[];

    constructor(editableColumnsIndex: number[]) {
        this._editableColumnsIndex = editableColumnsIndex;
    }

    public static forHeaderColumns(headerColumns: ExportDataValue[], editableHeaderColumns: string[]) {
        return new ExcelEditableColumnDecorator(editableHeaderColumns.map(e => headerColumns.indexOf(e) + 1)
            .filter(p => p !== 0));
    }

    public reset() {
        return;
    }

    public decorate(row: Excel.Row) {
        this._editableColumnsIndex.forEach(index => {
            const cell = row.getCell(index);

            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: {
                    argb: "FFFFFF99",
                },
            };
        });
    }
}
